const o=(o,t,i,n)=>{o&&"function"==typeof o&&(void 0===n?void 0===i?o(t):o(t,i):o(t,i,n))};export{o as safeCallback};
